module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-non-bodymatter element-container-single element-type-epigraph element-with-heading",
    attrs: {
      "epub:type": "epigraph",
      "id": "epigraph-2"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "epigraph-2-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Introduction to Il Gran Cavallo")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "epigraph-2-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('i', [_vm._v("I have no particular artistic ability, but I enjoy art; and I especially enjoy sculpture. All kinds, from classic representational to modern abstracts and more. I can spend hours wandering Frederik Meijer Gardens and Sculpture Park, one of the world’s best sculpture parks right here in West Michigan. And the centerpiece of Meijer Gardens is ")]), _vm._v("The American Horse "), _c('i', [_vm._v("by Nina Akamu, inspired by Da Vinci’s ")]), _vm._v("Horse. "), _c('i', [_vm._v("Frederik Meijer commissioned this 24-foot bronze horse, along with an identical horse for Milan.")]), _vm._v(" The American Horse "), _c('i', [_vm._v("is my muse, my inspiration—and my companion during my recovery from diabetes and an infection that almost killed me.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("So, this story is dedicated to the memory of Frederik Meijer, and to Nina Akamu. Thank you for adding to the beauty of the world.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ad22574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/introductiontoilgrancavallo.vue
// module id = 81
// module chunks = 0